import Lottie from 'lottie-react';
import aiLoadingIcon from '../jsons/ai-loading.json';

const AiLoading = props => {
  return <Lottie animationData={aiLoadingIcon} loop={true} {...props} />;
};

export default AiLoading;